"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var NS_PREFIX = exports.NS_PREFIX = "$sf::";
var NS_PRIMARY = exports.NS_PRIMARY = NS_PREFIX + "sflibs";
var NS_USER = exports.NS_USER = NS_PRIMARY + ".user";
var NS_CHAT = exports.NS_CHAT = NS_PRIMARY + ".chat";
var NS_CONTACTS = exports.NS_CONTACTS = NS_PRIMARY + ".contacts";
var NS_DOCKER = exports.NS_DOCKER = NS_PRIMARY + ".docker";
var NS_ACCESS_TOKEN = exports.NS_ACCESS_TOKEN = NS_PRIMARY + ".accesstoken";

var SUCCESS = exports.SUCCESS = "success";
var FAILED = exports.FAILED = "failed";
var HEADER = exports.HEADER = {
    'Content-Type': 'application/json'
};

var USER_TYPE = exports.USER_TYPE = {
    CLIENT: 'client',
    AGENT: 'agent'
};
var CHAT_REMOVED = exports.CHAT_REMOVED = "removed";
var CHAT_CLOSED = exports.CHAT_CLOSED = "closed";
var ACTIVITY_PAGE_VISIT = exports.ACTIVITY_PAGE_VISIT = "page visit";
var USER_TYPE_GUEST = exports.USER_TYPE_GUEST = "guest";

var MQTT_QOS = exports.MQTT_QOS = 1;
var MQTT_OFFLINE = exports.MQTT_OFFLINE = "offline";
var MQTT_ONLINE = exports.MQTT_ONLINE = "online";

var MESSAGE_DELIVERY_STATUS_INFLIGHT = exports.MESSAGE_DELIVERY_STATUS_INFLIGHT = "inflight";
var MESSAGE_DELIVERY_STATUS_DELIVERED = exports.MESSAGE_DELIVERY_STATUS_DELIVERED = "delivered";

var MESSAGE_CALL_TYPE_RECEIVE = exports.MESSAGE_CALL_TYPE_RECEIVE = "receive";
var MESSAGE_CALL_TYPE_SEND = exports.MESSAGE_CALL_TYPE_SEND = "send";
var MESSAGE_CALL_TYPE_ADD_PARTICIPANT = exports.MESSAGE_CALL_TYPE_ADD_PARTICIPANT = "add_participant";

var MESSAGE_ACTION_TYPING = exports.MESSAGE_ACTION_TYPING = "typing";
var MESSAGE_ACTION_SUBMIT = exports.MESSAGE_ACTION_SUBMIT = "submit";
var MESSAGE_ACTION_FOCUS = exports.MESSAGE_ACTION_FOCUS = "focus";
var MESSAGE_ACTION_JOIN = exports.MESSAGE_ACTION_JOIN = "joined";

var CHAT_TYPE = exports.CHAT_TYPE = "chat";
var CHAT_TYPE_GROUP = exports.CHAT_TYPE_GROUP = "group";
var CHAT_TYPE_ONE_TO_ONE = exports.CHAT_TYPE_ONE_TO_ONE = "one-to-one";

var CHAT_ACTION_MESSAGE_NEW = exports.CHAT_ACTION_MESSAGE_NEW = "message_receive";
var CHAT_ACTION_USER_START_TYPING = exports.CHAT_ACTION_USER_START_TYPING = "user_start_typing";
var CHAT_ACTION_FILE_SHARE = exports.CHAT_ACTION_FILE_SHARE = 'file-share';
var CHAT_EVENT_USER_JOIN = exports.CHAT_EVENT_USER_JOIN = "user_join";
var CHAT_EVENT_USER_LEAVE = exports.CHAT_EVENT_USER_LEAVE = "user_leave";
var CHAT_NEW_PARTICIPANT = exports.CHAT_NEW_PARTICIPANT = "new_participant";
var CHAT_UPDATE_PARTICIPANT_LIST = exports.CHAT_UPDATE_PARTICIPANT_LIST = "update_participant_list";

var CHAT_USER_START_TYPING_CHARACTER_LENGTH = exports.CHAT_USER_START_TYPING_CHARACTER_LENGTH = 3;

var CHAT_WINDOW_STATE_MINIMIZED = exports.CHAT_WINDOW_STATE_MINIMIZED = "DISPLAYMODE_MINIMIZED";
var CHAT_WINDOW_STATE_NORMAL = exports.CHAT_WINDOW_STATE_NORMAL = "DISPLAYMODE_NORMAL";
var CHAT_WINDOW_STATE_FULLSCREEN = exports.CHAT_WINDOW_STATE_FULLSCREEN = "DISPLAYMODE_FULLSCREEN";
var CHAT_WINDOW_STATE_ICON = exports.CHAT_WINDOW_STATE_ICON = "DISPLAYMODE_ICON";
var CHAT_WINDOW_STATE_HIDE = exports.CHAT_WINDOW_STATE_HIDE = "DISPLAYMODE_HIDE";

var DEFAULT_GUEST_NAME = exports.DEFAULT_GUEST_NAME = "Guest";
var DEFAULT_AGENT_NAME = exports.DEFAULT_AGENT_NAME = "Agent";
var DEFAULT_SELF_NAME = exports.DEFAULT_SELF_NAME = "You";

var PAYLOAD_ACTION = exports.PAYLOAD_ACTION = {
    MESSAGE_RECEIVED: "message_receive",
    NEW_MEETING: "meeting_created",
    USER_JOIN: "user_join",
    USER_LEAVE: "user_leave",
    USER_INVITE: "user_invite",
    USER_START_TYPING: "user_start_typing",
    MEETING_JOINED: "meeting_joined",
    INVITED: "meeting_invited",
    MEETING_ENDED: "meeting_ended",
    NETWORK_STATUS_CHANGE: "network_status_change",
    SYSTEM_INVITATION: "system_invite",
    USER_ACTIVITY: "user_activity"
};


// WEBPACK FOOTER //
// ../chat/lib/common/constants.js